import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { Row, Typography } from 'seagull';
import { chartColors } from '../chartColors';
import WithLegendDot from '../WithLegendDot/WithLegendDot';
import styles from './CustomTooltip.module.scss';
/**
 * Renders a tooltip to be used in recharts graphs using the recharts Tooltip component
 * with "content" prop.
 */ export default function CustomTooltip(props) {
    const { active, payload, label, testId, getItems, getTitle, getBody, withTitleSeparator = true } = props;
    const isDark = props.skin === 'dark';
    const standardSkin = isDark ? 'invertedStandard' : 'standard';
    const mutedSkin = isDark ? 'invertedSecondary' : 'secondary';
    const hasRelevantPayload = payload === null || payload === void 0 ? void 0 : payload.some((p)=>!!p.value);
    const title = getTitle ? getTitle(label, payload) : label;
    const hasTitle = title != null && String(title).length > 0;
    const items = getItems(payload === null || payload === void 0 ? void 0 : payload.filter((p)=>p.value)) || [];
    return active && hasRelevantPayload && items.length > 0 ? /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, isDark && styles.dark),
        "data-testid": testId,
        children: [
            hasTitle && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: isDark ? 'invertedStandard' : 'secondary',
                        weight: isDark ? 'bold' : 'light',
                        testId: testId && "".concat(testId, "-title"),
                        children: title
                    }),
                    withTitleSeparator && /*#__PURE__*/ _jsx("div", {
                        className: styles.separator,
                        "data-testid": testId && "".concat(testId, "-separator")
                    })
                ]
            }),
            getBody && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                skin: standardSkin,
                testId: testId && "".concat(testId, "-body"),
                children: getBody(payload)
            }),
            items.map((param, idx)=>{
                let { id, label, color, dataKey, inBrackets, suffix, amount, isGroupHeading, isOptional } = param;
                const rowSkin = isGroupHeading === true || isOptional === true ? mutedSkin : standardSkin;
                const row = /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "paragraph2",
                            skin: rowSkin,
                            children: [
                                label,
                                inBrackets && /*#__PURE__*/ _jsxs(Typography, {
                                    as: "span",
                                    variant: "paragraph2",
                                    skin: mutedSkin,
                                    children: [
                                        ' ',
                                        "(",
                                        inBrackets,
                                        ")"
                                    ]
                                }),
                                suffix && /*#__PURE__*/ _jsxs(Typography, {
                                    as: "span",
                                    variant: "paragraph2",
                                    skin: mutedSkin,
                                    children: [
                                        ' ',
                                        suffix
                                    ]
                                })
                            ]
                        }),
                        amount != null && /*#__PURE__*/ _jsx(Typography, {
                            className: styles.amount,
                            variant: "paragraph2",
                            skin: rowSkin,
                            children: amount
                        })
                    ]
                });
                return isGroupHeading === true ? /*#__PURE__*/ _jsx(Row, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    className: styles.headingRow,
                    testId: testId && "".concat(testId, "-item-").concat(idx),
                    children: row
                }, id) : /*#__PURE__*/ _jsx(WithLegendDot, {
                    color: color || chartColors.lightGray,
                    isHollow: isOptional,
                    className: cn(amount != null && styles.rowWithAmount),
                    testId: testId && "".concat(testId, "-item-").concat(idx),
                    "data-key": dataKey,
                    children: row
                }, id);
            })
        ]
    }) : null;
}
